import { Theme, createStyles, makeStyles } from "@material-ui/core";

export const useStandardStyles = makeStyles((theme: Theme) =>
    createStyles({
        flex: {
            display: 'flex',
        },
        flexGrow: {
            flexGrow: 1
        },
        flexColumn: {
            flexDirection: 'column'
        },
        fullWidth: {
            width: '100%'
        },
        flexWrap: {
            flexWrap: 'wrap'
        },
        justifyCenter: {
            justifyContent: 'center'
        },
        alignCenter: {
            alignItems: 'center'
        },
        noShrink: {
            flexShrink: 0
        },
        overflowHidden: {
            overflow: 'hidden'
        },
        truncateText: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        },
        bold: {
            fontWeight: 'bold'
        },
        italic: {
            fontStyle: 'italic'
        },
        relative: {
            position: 'relative'
        },
        overflowXAuto: {
            overflowX: 'auto'
        },
        required: {
            color: 'red'
        },
        lightBackground: {
            backgroundColor: theme.palette.primaryBackground.main
        },
        noPadding: {
            padding: '0px'
        }
    }),
);